// src/components/PolicyManagement/PolicyView/PolicyDetailSections/MoreActions.js
import React, { useContext, useMemo, useState } from 'react';
import FlexView from 'react-flexview/lib';
import { Collapse, IconButton } from '@material-ui/core';
import { KeyboardArrowDown as ExpandMoreIcon } from '@material-ui/icons';
import { GenerateEndorsementPopup } from '../../GenerateEndorsementPopup';
import { GenerateAcordEndorsementPopup } from '../../GenerateAcordEndorsementPopup';
import { awaitWithLoading } from '../../../../services/utils';
import { EventEmitterService, EventKey } from '../../../../services/EventEmitterService';
import { CancelPolicyPopup } from '../../CancelPolicyPopup';
import { LossPayeeEndorsementPopup } from '../../LossPayeeEndorsementPopup';
import { ModificationApi } from '../../../../api/modification.api';
import { InsuranceStatus } from '../../../../models/insurance-models/InsuranceStatus';
import { ManualEndorsementPopup } from '../../ManualEndorsementPopup';
import { ApproveRefundPopup } from '../../ApproveRefundPopup';
import { PolicyManagementContextStore } from '../../../../context/PolicyManagementContext';

export const AdminActions = ({shrink ,insurance}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const policyManagementContext = useContext(PolicyManagementContextStore)
    const hasAdditionalInsured = policyManagementContext.allAdditionalInsuredList.length > 0 ;
    const hasHullItems = insurance.insuredEquipmentList.length > 0 || insurance.insuredDroneList.length > 0
    const [genEndorsementPopupOpen, setGenEndorsementPopupOpen] = React.useState(false)
    const [genAcordEndorsementPopupOpen, setGenAcordEndorsementPopupOpen] = React.useState(false)
    const [manualEndorsementPopupOpen, setManualEndorsementPopupOpen] = React.useState(false)
    const [openCancelPopup, setOpenCancelPopup] = React.useState(false)
    const [isFullCancel,setIsFullCancel] = React.useState(false)
    const [openApproveCancel, setOpenApproveCancel] = React.useState({
        open: false,
        amount: 0,
        policyNumber: '',
        isNotRefund:false
    })
    const [cancelData, setCancelData] = React.useState({
        reason: '',
        comment: '',
        insuranceId:'',
        cancelDate: new Date(),
        fullRefund: false,
        isNotRefundReq:false
    })
    const [openLossPayee,setOpenLossPayee] = React.useState(false)
    const insuranceId = insurance.insuranceId
    const closeGenEndorsementPopupOpen = () => setGenEndorsementPopupOpen(false)
    const openGenEndorsementPopupOpen = () => setGenEndorsementPopupOpen(true)
    const closeGenAcordEndorsementPopupOpen = () => setGenAcordEndorsementPopupOpen(false)
    const openGenAcordEndorsementPopupOpen = () => setGenAcordEndorsementPopupOpen(true)
    const closeManualEndorsementPopupOpen = () => setManualEndorsementPopupOpen(false)

    const openFlatCancelPopup = () => {
        setIsFullCancel(true)
        setOpenCancelPopup(true)
    }

    const openProRataPopup = () => {
        setIsFullCancel(false)
        setOpenCancelPopup(true)
    }
    const actions = useMemo(() => [
        { label: "Generate Endorsement", onClick: openGenEndorsementPopupOpen, show: insurance.getStatus() != InsuranceStatus.INACTIVE },
        { label: "Generate ACORD Endorsement", onClick: openGenAcordEndorsementPopupOpen, show: insurance.getStatus() != InsuranceStatus.INACTIVE },
        { label: "Cancel - Pro rata refund", onClick: openProRataPopup, show: insurance.getStatus() != InsuranceStatus.INACTIVE },
        { label: "Cancel - Full refund", onClick: openFlatCancelPopup, show: true },
        { label: "Generate loss payee", onClick: () => setOpenLossPayee(true), show: hasAdditionalInsured && hasHullItems }
    ].filter(action => action.show), [insurance, hasAdditionalInsured, hasHullItems])



    const sendCancelRequest = async (data, insurance) => {
        let res = await awaitWithLoading(ModificationApi.getCancelAmount(insurance.insuranceId,data.selectedDate,data.fullRefund,data.isNotRefundReq))
        if (res.ok) {
            setCancelData({
                reason: data.cancellationReason,
                comment: data.comments,
                insuranceId:insurance.insuranceId,
                cancelDate: data.selectedDate,
                fullRefund: data.fullRefund,
                isNotRefundReq: data.isNotRefundReq
            })
            setOpenApproveCancel({
                open: true,
                isNotRefund:data.isNotRefundReq,
                amount: res.data.total
            })
        } else {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    } 

    const sendLossPayeeRequest = async (data) => {
        let res = await awaitWithLoading(ModificationApi.lossPayeeRequest(data.drones.map(item=>item.id),data.equipments.map(item=>item.id),data.selectedAdditionalInsured.id,insuranceId))
        if (res.ok) {
            EventEmitterService.dispatch(EventKey.ShowSuccess, {title: 'Success',
             body: 'The endorsement was generated successfully!',
             actionText: "View Endorsement",
             onClose: (val) => val == 1 && window.open(res.data.url_endoesement ,'_blank'),
        })
        } else {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    } 

    const cancelPolicy = async (data, insurance) => {
        let res = await awaitWithLoading(ModificationApi.cancelPolicy(
            cancelData.insuranceId,
            cancelData.cancelDate,
            cancelData.fullRefund,
            cancelData.comment,
            cancelData.reason,
            cancelData.isNotRefundReq
            )
        )

        if (res.ok) {
            EventEmitterService.dispatch(EventKey.ShowSuccess, {title: 'Success',
             body: 'The policy was canceled successfully!',
             onClose: () => {
                window.location.reload(false)
            },
        })
        } else {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }

    return (
        <>
            <FlexView vAlignContent="center" className="space-between">
                <span className="text-body bold">Admin Actions</span>
                <FlexView
                onClick={() => setIsExpanded(!isExpanded)}
                    className='clickable'
                >

                {!shrink && <FlexView vAlignContent="center" className='bold blue' >
                        Show
                    </FlexView>}
                <FlexView 
                    vAlignContent="center" 
                    className="blue "
                >
                    <IconButton 
                    className="blue "
                    style={{ 
                        transform: isExpanded ? 'rotate(180deg)' : 'rotate(0)',
                        transition: 'transform 0.3s'
                    }}
                >
                    <ExpandMoreIcon fontSize="small" />
                </IconButton>
                </FlexView>
                </FlexView>

            </FlexView>

            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                <FlexView column className="padding-vertical-basic">
                    {actions.map((action, index) => (
                        <FlexView 
                            key={index}
                            vAlignContent="center" 
                            className="blue clickable margin-bottom-small"
                            onClick={action.onClick}
                        >
                            <span className="text-small">{action.label}</span>
                        </FlexView>
                    ))}
                </FlexView>
            </Collapse>
            <CancelPolicyPopup onCancel={()=>setOpenCancelPopup(false)} insuranceId={insuranceId} open={openCancelPopup} onConfirm={sendCancelRequest} fullRefund={isFullCancel} policyStartDate ={insurance.validFromUtc}/>
            <ApproveRefundPopup openApproveCancel ={openApproveCancel} onApprove={()=>cancelPolicy()} onClose={()=>setOpenApproveCancel({open: false,amount: 0,isNotRefund:false})}/>
            <LossPayeeEndorsementPopup onCancel={()=>setOpenLossPayee(false)} insuranceId={insuranceId} open={openLossPayee} onConfirm={sendLossPayeeRequest}/>
            <GenerateEndorsementPopup insuranceId={insuranceId} open={genEndorsementPopupOpen} onCancel={closeGenEndorsementPopupOpen} />
            <GenerateAcordEndorsementPopup insuranceId={insuranceId} open={genAcordEndorsementPopupOpen} onCancel={closeGenAcordEndorsementPopupOpen} />
            <ManualEndorsementPopup insuranceId={insuranceId} open={manualEndorsementPopupOpen} onCancel={closeManualEndorsementPopupOpen} />
        </>
    );
};